import React, { useRef } from "react";

const Receipt = ({ receipt, council }) => {
  const receiptRef = useRef();
  console.log(receipt)
  // Function to print receipt
  const handlePrint = () => {
    const printContent = receiptRef.current.innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload(); // Refresh after printing
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white text-black shadow-md rounded-md border border-gray-300">
      <div ref={receiptRef} className="text-sm font-mono">
        <h2 className="text-center font-bold text-lg">RECEIPT</h2>
        <h2 className="text-center font-bold">{council}</h2>
        <p><strong>Receipt #:</strong> {receipt.voucher}</p>
        <p><strong>Date:</strong> {new Date(receipt.date).toLocaleDateString()}</p>
        <p><strong>Customer:</strong> {receipt.paye}</p>

        <table className="w-full text-left border-collapse mt-2">
          <thead>
            <tr className="border-b">
              <th className="p-1">Description</th>
              <th className="p-1">COA</th>
              <th className="p-1 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {receipt.transactions.map((item, idx) => (
              <tr key={idx} className="border-b">
                <td className="p-1">{item.description}</td>
                <td className="p-1">{item.coa_id}</td>
                <td className="p-1 text-right">{parseFloat(item.amount).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p className="text-right mt-2"><strong>Total: </strong> K{receipt.transactions.reduce((sum, t) => sum + parseFloat(t.amount), 0).toFixed(2)}</p>
      </div>

      <button
        onClick={handlePrint}
        className="mt-4 w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600"
      >
        Print Receipt
      </button>
    </div>
  );
};

export default Receipt;